"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
require("core-js/modules/es6.string.starts-with");
var _decorate = require("@/api/zdyPage/decorate");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'decorate',
  props: {
    datas: Object
  },
  data: function data() {
    return {
      resPath: process.env.VUE_APP_IMAGE_PATH,
      imageUrl: '',
      backgroundFileList: [],
      rules: {
        //校验表单输入
        name: [
        //页面名称
        {
          required: true,
          message: '请输入页面名称',
          trigger: 'blur'
        }],
        details: [
        //页面描述
        {
          required: true,
          message: '请输入页面描述',
          trigger: 'blur'
        }],
        type: [
        //页面类型
        {
          required: true,
          message: '请选择页面类型',
          trigger: 'change'
        }],
        pageIndex: [
        //页面标识
        {
          required: true,
          message: '请输入页面标识',
          trigger: 'blur'
        }],
        bgColor: [
        //背景颜色
        {
          required: true,
          message: '请选择背景颜色',
          trigger: 'change'
        }],
        classification: [
        //分类
        {
          required: true,
          message: '请选择页面分类',
          trigger: 'blur'
        }]
      },
      predefineColors: [
      // 颜色选择器预设
      '#ff4500', '#ff8c00', '#ffd700', '#90ee90', '#00ced1', '#1e90ff', '#c71585', '#409EFF', '#909399', '#C0C4CC', 'rgba(255, 69, 0, 0.68)', 'rgb(255, 120, 0)', 'hsv(51, 100, 98)', 'hsva(120, 40, 94, 0.5)', 'hsl(181, 100%, 37%)', 'hsla(209, 100%, 56%, 0.73)', '#c7158577'],
      uploadImgDataType: null // 获取到的图片地址属于哪一类别   0 修改底部logo   1 修改店铺图标 2 页面背景图
    };
  },
  created: function created() {
    this.initBackgroundImage();
  },
  methods: {
    initBackgroundImage: function initBackgroundImage() {
      // 初始化背景图片显示
      if (this.datas && this.datas.backgroundImg) {
        this.backgroundFileList = [{
          name: '背景图片',
          url: this.resPath + this.datas.backgroundImg,
          uid: Date.now()
        }];
      }
    },
    handleRemoveFile: function handleRemoveFile() {
      this.imageUrl = '';
      this.backgroundFileList = [];
      // 同时更新datas中的背景图片
      this.datas.backgroundImg = '';
    },
    handlePreview: function handlePreview(file) {
      // 预览文件
      console.log('Preview file:', file);
    },
    handlePictureUpload: function handlePictureUpload(_ref) {
      var _this = this;
      var file = _ref.file;
      // 验证文件格式和大小
      var isImage = file.type.startsWith('image/');
      var isLt2M = file.size / 1024 / 1024 < 2;
      if (!isImage) {
        this.$message.error('上传文件只能是图片格式!');
        return;
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 2MB!');
        return;
      }
      var formData = new FormData();
      formData.append('file', file);
      (0, _decorate.uploadImg)(formData).then(function (res) {
        if (res.code === 200) {
          // 后端返回 { code, data: { pathKey } }，取 pathKey 作为图片路径
          var imgPath = res.data && res.data.pathKey ? res.data.pathKey : res.data;
          _this.imageUrl = imgPath;
          _this.datas.backgroundImg = imgPath; // 更新datas中的背景图片
          // 更新文件列表以显示上传的图片
          _this.backgroundFileList = [{
            name: file.name,
            url: _this.resPath + imgPath,
            uid: Date.now()
          }];
          _this.$message.success('上传成功');
        } else {
          _this.$message.error('上传失败' + res.message);
        }
      }).catch(function (err) {
        _this.$message.error('上传失败:' + err);
        console.log(err);
      });
    }
  },
  watch: {
    // 监听 backgroundImg 变化
    'datas.backgroundImg': {
      handler: function handler(newVal) {
        if (newVal) {
          this.initBackgroundImage();
        }
      },
      immediate: true // 立即执行一次，处理初始值
    },
    'datas.type': {
      handler: function handler(newVal, oldVal) {
        if (newVal == '1') {
          this.datas.pageIndex = 'index';
        } else if (oldVal == '1') {
          // 只在从1变成其他值时清空
          this.datas.pageIndex = '';
        }
      } // immediate: true
    }
  }
};